import { ICoordinates, IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';

import { MapPin } from '../../../components/MapPin';
import { EType } from '../../../types/map';
import { INFRASTRUCTURE_MAIN } from '../MapContainer';

interface IGetGeoObjectOptions {
  name: 'main' | EType;
  coordinates: ICoordinates;
  id: string;
  price?: string;
  active?: boolean;
}

export const getGeoObject = ({ name, coordinates, id, price, active }: IGetGeoObjectOptions): IGeoObject => {
  const size = name === INFRASTRUCTURE_MAIN ? 54 : 32;

  return {
    type: 'Point',
    name,
    options: {
      coordinates,
      html: ReactDOMServer.renderToStaticMarkup(<MapPin id={id} type={name} price={price} active={active} />),
      id,
      width: size,
      height: size,
    },
  };
};
